import { Button, Icon, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigateToTop } from "../../libs/useNavigateToTop";
import AppBarRoot from "./Root";
import AppBarMenu from "./Menu";
import { ArrowBack, ArrowLeft, Share } from "@mui/icons-material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ScheduleService from "../ScheduleService";

function AppBarSiteSetup({ isMyGarden, clientUuid, clientName, siteUuid }) {
  const navigate = useNavigateToTop();

  return (
    <AppBarRoot
      startAction={
        <Stack direction={"row"} spacing={2}>
          <IconButton onClick={() => navigate(-1)} style={{ color: "white" }}>
            <ArrowBack />
          </IconButton>
          <Typography
            onClick={() => navigate("/")}
            variant="h5"
            style={{ alignSelf: "center", color: "white" }}
          >
            {isMyGarden
              ? "My Garden"
              : clientName
              ? `${clientName}'s`
              : "Garden"}
          </Typography>
        </Stack>
      }
      endAction={
        <Stack direction={"row"} spacing={1}>
          {/* <Button
            startIcon={<CalendarMonthIcon />}
            variant="contained"
            onClick={onShceduleClicked}
          >
            Schedule
          </Button> */}
          <ScheduleService
            clientUuid={clientUuid}
            clientName={clientName}
            siteUuid={siteUuid}
          />
        </Stack>
      }
    />
  );
}

export default AppBarSiteSetup;
